/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class ProfileApi extends runtime.BaseAPI {
    /**
     * Set the tags for a profile. Expects a JSON body of the form {\"tags\": [\"tag1\", \"tag2\", ...]}. Returns the normalized, de-duplicated list of tags actually saved.
     * Set Tags
     */
    async setTagsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling setTags().');
        }
        if (requestParameters['bodySetTags'] == null) {
            throw new runtime.RequiredError('bodySetTags', 'Required parameter "bodySetTags" was null or undefined when calling setTags().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/profile/{profile_id}/tags`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['bodySetTags'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Set the tags for a profile. Expects a JSON body of the form {\"tags\": [\"tag1\", \"tag2\", ...]}. Returns the normalized, de-duplicated list of tags actually saved.
     * Set Tags
     */
    async setTags(requestParameters, initOverrides) {
        const response = await this.setTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Bulk import multiple profiles and assign them to a target account. (Admin only)
     * Bulk Profile Import
     */
    async v1ImportProfilesRaw(requestParameters, initOverrides) {
        if (requestParameters['targetUser'] == null) {
            throw new runtime.RequiredError('targetUser', 'Required parameter "targetUser" was null or undefined when calling v1ImportProfiles().');
        }
        if (requestParameters['bodyV1ImportProfiles'] == null) {
            throw new runtime.RequiredError('bodyV1ImportProfiles', 'Required parameter "bodyV1ImportProfiles" was null or undefined when calling v1ImportProfiles().');
        }
        const queryParameters = {};
        if (requestParameters['targetUser'] != null) {
            queryParameters['target_user'] = requestParameters['targetUser'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/profile/import_profiles`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['bodyV1ImportProfiles'],
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Bulk import multiple profiles and assign them to a target account. (Admin only)
     * Bulk Profile Import
     */
    async v1ImportProfiles(requestParameters, initOverrides) {
        const response = await this.v1ImportProfilesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Export a profile as JSON data that can be imported later
     * Profile Export
     */
    async v1ProfileExportRaw(requestParameters, initOverrides) {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError('body', 'Required parameter "body" was null or undefined when calling v1ProfileExport().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/profile/export_profile`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Export a profile as JSON data that can be imported later
     * Profile Export
     */
    async v1ProfileExport(requestParameters, initOverrides) {
        const response = await this.v1ProfileExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Import Profile from Profile object
     * Profile Import
     */
    async v1ProfileImportV2Raw(requestParameters, initOverrides) {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError('requestBody', 'Required parameter "requestBody" was null or undefined when calling v1ProfileImportV2().');
        }
        const queryParameters = {};
        if (requestParameters['addAdditionalTitle'] != null) {
            queryParameters['add_additional_title'] = requestParameters['addAdditionalTitle'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/profile/import_v2`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Import Profile from Profile object
     * Profile Import
     */
    async v1ProfileImportV2(requestParameters, initOverrides) {
        const response = await this.v1ProfileImportV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Import/Copy a Tab from one Profile to another (or within the same Profile)
     * Tab Import
     */
    async v1TabImportRaw(requestParameters, initOverrides) {
        if (requestParameters['bodyV1TabImport'] == null) {
            throw new runtime.RequiredError('bodyV1TabImport', 'Required parameter "bodyV1TabImport" was null or undefined when calling v1TabImport().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/profile/import_tab`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['bodyV1TabImport'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Import/Copy a Tab from one Profile to another (or within the same Profile)
     * Tab Import
     */
    async v1TabImport(requestParameters, initOverrides) {
        const response = await this.v1TabImportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Import multiple tabs into a target profile
     * Tabs Batch Import
     */
    async v1TabsBatchImportRaw(requestParameters, initOverrides) {
        if (requestParameters['bodyV1TabsBatchImport'] == null) {
            throw new runtime.RequiredError('bodyV1TabsBatchImport', 'Required parameter "bodyV1TabsBatchImport" was null or undefined when calling v1TabsBatchImport().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/profile/import_tabs_batch`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['bodyV1TabsBatchImport'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Import multiple tabs into a target profile
     * Tabs Batch Import
     */
    async v1TabsBatchImport(requestParameters, initOverrides) {
        const response = await this.v1TabsBatchImportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new profile for the current account.
     * Profile Create
     */
    async v2ProfileCreateRaw(requestParameters, initOverrides) {
        if (requestParameters['profileCreate'] == null) {
            throw new runtime.RequiredError('profileCreate', 'Required parameter "profileCreate" was null or undefined when calling v2ProfileCreate().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/profile/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['profileCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new profile for the current account.
     * Profile Create
     */
    async v2ProfileCreate(requestParameters, initOverrides) {
        const response = await this.v2ProfileCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a profile by profile ID. Only allowed if the current user has access.
     * Profile Delete
     */
    async v2ProfileDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling v2ProfileDelete().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/profile/{profile_id}`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Delete a profile by profile ID. Only allowed if the current user has access.
     * Profile Delete
     */
    async v2ProfileDelete(requestParameters, initOverrides) {
        const response = await this.v2ProfileDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create new profile.
     * Profile Duplicate
     */
    async v2ProfileDuplicateRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling v2ProfileDuplicate().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/profile/duplicate/{profile_id}`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create new profile.
     * Profile Duplicate
     */
    async v2ProfileDuplicate(requestParameters, initOverrides) {
        const response = await this.v2ProfileDuplicateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List profiles belonging to the current account and accessible users.
     * Profiles List All
     */
    async v2ProfileListAllRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/profile/`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List profiles belonging to the current account and accessible users.
     * Profiles List All
     */
    async v2ProfileListAll(requestParameters = {}, initOverrides) {
        const response = await this.v2ProfileListAllRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a slim profile (basic information) by profile ID.
     * Profile Read
     */
    async v2ProfileReadRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling v2ProfileRead().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/profile/{profile_id}`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a slim profile (basic information) by profile ID.
     * Profile Read
     */
    async v2ProfileRead(requestParameters, initOverrides) {
        const response = await this.v2ProfileReadRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get detailed profiles grouped by the given usernames.
     * Profile Read By Usernames
     */
    async v2ProfileReadByUsersRaw(requestParameters, initOverrides) {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError('requestBody', 'Required parameter "requestBody" was null or undefined when calling v2ProfileReadByUsers().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/profile/list/details`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get detailed profiles grouped by the given usernames.
     * Profile Read By Usernames
     */
    async v2ProfileReadByUsers(requestParameters, initOverrides) {
        const response = await this.v2ProfileReadByUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a detailed profile by profile ID.
     * Profile Read Details
     */
    async v2ProfileReadDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling v2ProfileReadDetails().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/profile/{profile_id}/details`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a detailed profile by profile ID.
     * Profile Read Details
     */
    async v2ProfileReadDetails(requestParameters, initOverrides) {
        const response = await this.v2ProfileReadDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update an existing profile by profile ID.
     * Profile Update
     */
    async v2ProfileUpdateRaw(requestParameters, initOverrides) {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling v2ProfileUpdate().');
        }
        if (requestParameters['profileUpdate'] == null) {
            throw new runtime.RequiredError('profileUpdate', 'Required parameter "profileUpdate" was null or undefined when calling v2ProfileUpdate().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/profile/{profile_id}`;
        urlPath = urlPath.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['profileUpdate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Update an existing profile by profile ID.
     * Profile Update
     */
    async v2ProfileUpdate(requestParameters, initOverrides) {
        const response = await this.v2ProfileUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Force-delete **all** profiles belonging to the **username**. Uses `crud.profile.force_remove(...)` to physically delete each profile and its children (tabs → maps → layers) via ORM cascades.  Returns a summary of deleted IDs and any errors encountered.
     * Profiles Force Delete
     */
    async v2ProfilesForceDeleteUnsafeRaw(requestParameters, initOverrides) {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError('username', 'Required parameter "username" was null or undefined when calling v2ProfilesForceDeleteUnsafe().');
        }
        const queryParameters = {};
        if (requestParameters['username'] != null) {
            queryParameters['username'] = requestParameters['username'];
        }
        if (requestParameters['markedOnly'] != null) {
            queryParameters['marked_only'] = requestParameters['markedOnly'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/profile/admin/force-delete`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Force-delete **all** profiles belonging to the **username**. Uses `crud.profile.force_remove(...)` to physically delete each profile and its children (tabs → maps → layers) via ORM cascades.  Returns a summary of deleted IDs and any errors encountered.
     * Profiles Force Delete
     */
    async v2ProfilesForceDeleteUnsafe(requestParameters, initOverrides) {
        const response = await this.v2ProfilesForceDeleteUnsafeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Reset the test account to contain valid E2E test data. Only the special test user can perform this action.
     * Reset Test Profiles
     */
    async v2ResetTestProfilesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/profile/test/reset`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Reset the test account to contain valid E2E test data. Only the special test user can perform this action.
     * Reset Test Profiles
     */
    async v2ResetTestProfiles(initOverrides) {
        const response = await this.v2ResetTestProfilesRaw(initOverrides);
        return await response.value();
    }
    /**
     * List profiles belonging to the current account and accessible users.
     * Slim Profiles List All
     */
    async v2SlimProfileListAllRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/profile/all-profiles-slim`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List profiles belonging to the current account and accessible users.
     * Slim Profiles List All
     */
    async v2SlimProfileListAll(initOverrides) {
        const response = await this.v2SlimProfileListAllRaw(initOverrides);
        return await response.value();
    }
}
